module.exports = __webpack_public_path__ + "b287f3efb847dd0d6d4d43e1a9d6be9f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-12.png
// module id = 2208
// module chunks = 0